export const getProfileMeUrl = ({
  version = 'v2',
}: { version?: string } = {}) => `/api/${version}/profile/me`;
